export enum LogCategory {
    ActionLogs = "ActionLogs",
    ActionEvents = "ActionEvents",
    ActionMetrics = "ActionMetrics",
    ActionExceptions = "ActionExceptions"
}